export default __webpack_public_path__ + "static/media/Email- Attachment.e9f8a7bb.png";